import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ranking from "./components/Ranking";
import CardFlow from "./components/CardFlow";
import Directory from "./components/Directory";
import Roundup from "./components/Roundup";
import Stats from "./components/Stats";
import EntryCta from "./components/EntryCta";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 w-full">
        <Hero />
        <Ranking />
        <CardFlow />
        <Directory />
        <Roundup />
        <Stats />
        <EntryCta />
      </main>
      <Footer />
    </div>
  );
}